export const convertReactIconToUrl = (type, color) => {
  const svgString = `<svg 
  width="800px" height="800px" 
  viewBox="0 0 12 12" enable-background="new 0 0 12 12" 
  version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M6,0C3.2385864,0,1,2.2385864,1,5s2.5,5,5,7c2.5-2,5-4.2385864,5-7S8.7614136,0,6,0z M6,7  C4.8954468,7,4,6.1045532,4,5s0.8954468-2,2-2s2,0.8954468,2,2S7.1045532,7,6,7z" fill="${color}"/></svg>`;

  const svgCommunityString = `<svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
    width="800px" height="800px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
  <path fill="${color}" d="M56,0H8C5.789,0,4,1.789,4,4v56c0,2.211,1.789,4,4,4h20V48h8v16h20c2.211,0,4-1.789,4-4V4
    C60,1.789,58.211,0,56,0z M28,40h-8v-8h8V40z M28,24h-8v-8h8V24z M44,40h-8v-8h8V40z M44,24h-8v-8h8V24z"/>
  </svg>`;

  const svgHomeString = `<svg width="800px" height="800px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0L0 6V8H1V15H4V10H7V15H15V8H16V6L14 4.5V1H11V2.25L8 0ZM9 10H12V13H9V10Z" fill="${color}"/>
  </svg>`;

  const blob = new Blob(
    [
      type === "PROVIDER_HOME"
        ? svgHomeString
        : type === "COMMUNITY_HOME"
        ? svgCommunityString
        : svgString,
    ],
    { type: "image/svg+xml" }
  );
  return URL.createObjectURL(blob);
};

export const getCustomMarkerIcon = (type, color) => {
  // Convert color to dot color name that Google Maps supports
  const getGoogleMarkerColor = (hexColor) => {
    const colors = {
      '#9333EA': 'purple',
      '#2563EB': 'blue',
      '#DC2626': 'red',
      '#000000': 'black',
      // Add more color mappings as needed
    };
    return colors[hexColor] || 'red';  // default to red if color not found
  };

  const markerColor = getGoogleMarkerColor(color);
  return {
    url: `http://maps.google.com/mapfiles/ms/icons/${markerColor}-dot.png`,
    scaledSize: new window.google.maps.Size(32, 32),
  };
};
